<template>
  <section class="black-bg">
    <div class="containerWrapper">
      <div class="aboutEvent">
        <div class="aboutEvent__lft">
          <img
            class="js-tilt"
            src="../assets/ornament_curly.svg"
            alt="curly braces"
          />
        </div>
        <div class="aboutEvent__rgt">
          <h2 class="hero-subheading">
            What We Are <span class="text-outline">About</span>
          </h2>
          <p class="lead">
            Syntax 2021 is a platform to share well-formed thoughts, ideas, and
            experiences around innovation and technology. It is an environment
            for tech enthusiasts to foster conversations that shape the modern
            IT world.
          </p>
          <br />
          <p class="lead">
            Through this global conference, we want to inform, educate and
            connect with aspirants as well as professionals from around the
            globe, who will in turn lead the way to the glorious future of IT
            and tech.
          </p>
        </div>
        <div class="aboutEvent__empty"></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "About",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.aboutEvent {
  color: var(--text-white);
}

.aboutEvent {
  display: grid;
  grid-template-columns: 13% auto auto 15%;
  grid-template-rows: 1fr;
  gap: 0px 30px;
  grid-auto-flow: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  grid-template-areas: "aboutEvent__lft aboutEvent__rgt aboutEvent__rgt aboutEvent__empty";
  margin-bottom: 3rem;
  padding: 6rem 0rem;
}

.aboutEvent__lft {
  grid-area: aboutEvent__lft;
}

.aboutEvent__rgt {
  grid-area: aboutEvent__rgt;
}

.aboutEvent__empty {
  grid-area: aboutEvent__empty;
}

.aboutEvent__rgt h2 {
  font-size: 3rem;
}

.aboutEvent__rgt h2.hero-subheading {
  margin-bottom: 1rem;
}

.aboutEvent__rgt p {
  font-size: 1.3rem;
}

.text-outline {
  -webkit-text-stroke: 1.5px var(--text-white);
  color: var(--bg-black);
}

@media (max-width: 1200px) {
  .aboutEvent,
  .navbarTop {
    padding: 0px 30px;
  }
}

@media (max-width: 992px) {
  .aboutEvent {
    grid-template-columns: 1fr;
    grid-template-areas: "aboutEvent__lft";
  }
  .aboutEvent .aboutEvent__lft,
  .aboutEvent__empty {
    display: none;
  }
  .aboutEvent__rgt {
    text-align: center;
  }
}
@media (max-width: 576px) {
  .aboutEvent {
    grid-template-columns: 1fr;
    grid-template-areas: "aboutEvent__rgt";
    padding: 0px 0px;
  }
}
</style>
